import { testimonials } from "../../../mocks/testimonials";

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="w-full bg-white py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="mb-14 md:mb-18">
          <span className="inline-block text-sm font-medium text-[#4CAF50] border border-[#4CAF50]/30 rounded-full px-4 py-1.5 mb-5">
            What our users say
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 tracking-tight">
            Thousands of Happy Users
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-6 md:p-7 border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className={`w-11 h-11 ${t.avatarColor} rounded-full flex items-center justify-center text-sm font-bold text-gray-700`}
                >
                  {t.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-400">{t.handle}</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-0.5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span
                    key={i}
                    className="w-4 h-4 flex items-center justify-center text-[#FFC107]"
                  >
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}